<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">contact_mail</mat-icon>
    CONTACT US
  </div>
  <button type="button" aria-label="Close" (click)="cancel()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<div class="modal-body">
    <div class="loader" *ngIf="!isContactAvailable">
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </div>
    <div *ngIf="isContactAvailable">
        <h6>{{contactDetails[0] | uppercase }}</h6>
        <div class="box">
            <h5>{{contact1Label}}</h5>
            <div class="content">
                {{contact1Value}}
            </div>
        </div>
        <div class="box">
            <h5>{{ contact2Label }}</h5>
            <div class="content">
                {{contact2Value}}
            </div>
        </div>
    </div>
</div>
